import { Component, OnInit } from '@angular/core';
import * as printJS from 'print-js';
import swal from "sweetalert2";
import * as xlsx from 'xlsx';
import { InvoiceService } from 'src/app/services/invoice.service';
import { Company } from 'src/app/models/company';
import { CompanyService } from 'src/app/services/company.service';
import { AccessService } from 'src/app/services/access.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { LetrasPipe } from 'src/app/pipe/letras/letras.pipe';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-cancellation-invoice',
  templateUrl: './cancellation-invoice.component.html',
  styleUrls: ['./cancellation-invoice.component.scss'],
  providers: [InvoiceService, CompanyService, AccessService, UtilsService]
})
export class CancellationInvoiceComponent implements OnInit {
  loading;
  // Variables auxiliares
  pipeLetra = new LetrasPipe();
  pipeFecha = new DatePipe('en-US');
  company = {} as Company;
  public isBeginning: boolean;
  public isReprint: boolean;
  public isPrintT: boolean;
  public isPrintL: boolean;
  public isDisabled: boolean;
  public userCommerceCode: number;
  public begDate: string;
  public endDate: string;
  public reasonForCancellation;
  public userCode: number;
  public storeCode: number;
  public companyCode: number;
  public storeName: string;
  public settings = {
    columns: {
      fecha: {
        title: 'Fecha'
      },
      invoiceAuthorization: {
        title: 'No. de Autorización'
      },
      serie: {
        title: 'Serie Fel',
      },
      factura: {
        title: 'No. Factura Fel'
      },
      invoiceInternSerial: {
        title: 'Serie Interna'
      },
      invoiceInternNumber: {
        title: 'Correlativo Interna',
      },
      invoiceSubtotal: {
        title: 'Sub Total',
        type: 'number'
      },
      invoiceTax: {
        title: 'IVA',
        type: 'number'
      },
      total: {
        title: 'Total',
        type: 'number'
      },
      nit: {
        title: 'Nit',
      },
      cliente: {
        title: 'Cliente',
      },
      estado: {
        title: 'Estado',
      },
      usuario: {
        title: 'Usuario',
      }
    }
  };

  // variables para data table
  public test: any = `<button (click)="onSelect($event)">Click me</button>`;
  public entries: number = 10;
  public selected: any[] = [];
  public activeRow: any;
  public temp = new Array();
  public invoiceList: any[] = new Array();

  //Reprint
  public dte: any;
  public fel: any;
  public felDetail: any;
  public felComplement: any;
  public companyLogoUrl: string;

  constructor(
    private _pipeNumero: DecimalPipe,
    private _utilsService: UtilsService,
    private _accessService: AccessService,
    private _invoiceService: InvoiceService,
    private _companyService: CompanyService
  ) { }

  async ngOnInit() {
    // GET ID USER & ID COMPANY
    let _data = JSON.parse(localStorage.getItem('data'));
    this.storeName = _data.storeName ? _data.storeName.toString() : null;
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;

    this.begDate = this._utilsService.dateTime('yyy-MM-dd');
    this.endDate = this._utilsService.dateTime('yyy-MM-dd');
    // this.begDate = '2022-08-01'; // Carrrizal, revisar orden
    // this.endDate = '2022-08-31';
    this.companyLogoUrl = '../../../assets/img/Clever-azul-original.png';

    this.viewBeginning();
    await this.getCompany(this.companyCode);
  }

  ///////////////////////PANTALLAS///////////////////////
  viewBeginning() {
    this.isBeginning = true;
    this.isReprint = false;
    this.isPrintT = false;
    this.isPrintL = false;
  }

  viewReprint() {
    this.isBeginning = false;
    this.isReprint = true;
    this.isPrintT = false;
    this.isPrintL = false;
  }

  viewPrint() {
    this.isBeginning = false;
    this.isReprint = false;
    this.company.companyInvoicePrint === 1 ? this.isPrintT = true : this.printLetter();
  }

  printTest() {
    printJS({
      printable: "printSection",
      type: "html",
      style: "#printSection{width: 224px; text-align: center}",
    });
  }

  ///////////////////////FUNCIONES PARA TABLA///////////////////////
  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    let val = $event.target.value.toLowerCase(); 
    this.temp = this.invoiceList.filter(function (d) {

      for (var key in d) {
        if (d[key] !== null) {
          if (d[key].toString().toLowerCase().indexOf(val) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  onActivate(event) {
    this.activeRow = event.row;
  }

  ///////////////////////COMPANY///////////////////////
  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];
          this.company.companyLogo != 'undefined' ? this.companyLogoUrl = this.company.companyLogoUrl : ''; 
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  ///////////////////////CRUD///////////////////////
  //Ver todas las factura
  getAll() {
    this.isDisabled = true;
    if (this.begDate && this.endDate) {
      this.loading = true;

      let json = {
        "storeCode": this.storeCode,
        "begDate": this.begDate,
        "endDate": this.endDate
      }

      this._invoiceService.getAllByCompany(json).then(
        async (response) => {
          console.log(response);
          if (response.result == true) {
            // await  this._utilsService.order(response.records, 'correlativo'); 
            // await  this._utilsService.orderDate(response.records, 'fecha', '-'); 
            this.invoiceList = response.records; // Ordenado 
            // await  this._utilsService.order(this.invoiceList, 'correlativo'); 
            // await  this._utilsService.order(this.invoiceList, 'fecha', 'correlativo'); 
            // await  this._utilsService.order(this.invoiceList, 'correlativo', 'fecha'); //este
            this.temp = this.invoiceList;            
            this.isReprint = true;
            this._utilsService.showNotification(1, response.message);
          } else {
            this.isDisabled = false;
            this._utilsService.showNotification(3, response.errorMessage);
          }
        },
        error => {
          this.isDisabled = false;
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.loading = false;
        this.isDisabled = false;
      });
    } else {
      this.isDisabled = false;
      // Mostrar notificación
      this._utilsService.showNotification(2, "Ingresar Datos");
    }
  }

  // Obtener una Factura
  searchInvoice($event) {
    $event.preventDefault();
    this.loading = true;

    //INFILE
    if (this.company.companyCertifier == 0) {
      if (this.company.companyPDFType == 1) {
        this._invoiceService.getOneMegaprint(this.activeRow.id).then(
          (response) => {
            if (response.result == true) {
              this.fel = response.records;
              this.felDetail = response.records.detail;              
              this.felComplement = {
                cliente: this.activeRow.cliente, nit: this.activeRow.nit, direccion: this.activeRow.clientAddress,
                certificador: "INFILE, S.A.", nitCertificador: 12521337
              };
              this.viewPrint();
            } else {
              this._utilsService.showNotification(3, response.errorMessage);
            }
          },
          error => {
            this._utilsService.showNotification(2, error);
            console.log(error);
          }
        ).finally(() => {
          this.isDisabled = false;
          this.loading = false;
        });
      } else {
        let uuid = this.activeRow.invoiceAuthorization;
        window.open('https://report.feel.com.gt/ingfacereport/ingfacereport_documento?uuid=' + uuid, 'popup', 'width=600,height=600');
        this.loading = false;
      }
    }
    //MEGAPRINT
    else if (this.company.companyCertifier == 1) {
      this._invoiceService.getOneMegaprint(this.activeRow.id).then(
        (response) => {
          if (response.result == true) {
            if (this.company.companyInvoiceFuel == 1 || this.company.companyPDFType == 1) {
              this.fel = response.records;
              this.felDetail = response.records.detail;
              this.felComplement = {
                cliente: this.activeRow.cliente, nit: this.activeRow.nit, direccion: this.activeRow.clientAddress,
                certificador: "MEGAPRINT, S.A.", nitCertificador: 50510231
              };
              this.viewPrint();
            } else {
              var pdfResult = response.records.pdfBase64;
              let pdfWindow = window.open("")
              pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe>");
            }
          } else {
            this._utilsService.showNotification(3, response.errorMessage);
          }
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.isDisabled = false;
        this.loading = false;
      });
    }
  }

  // Anular Factura
  getAnnular($event) {
    $event.preventDefault();

    console.log('anulacion',this.activeRow);

    swal.fire({
      title: "¿Cúal es el motivo de la anulación?",
      html:
        '<div class="form-group">' +
        '<input id="input-field" type="text" class="form-control" />' +
        "</div>",
      icon: "warning",
      showCancelButton: true,
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      confirmButtonText: "Solicitar",
      buttonsStyling: false
    })
      .then(result => {
        this.reasonForCancellation = (document.getElementById("input-field") as HTMLInputElement).value;
        if (result.value) {

          if(this.reasonForCancellation == undefined || this.reasonForCancellation == '') {
            swal.fire({
              title: "Error!",
              text: "Ingresar Motivo de Anulación.",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
              buttonsStyling: false
            });
          }
          else if(this.reasonForCancellation.length <= 15) {
            swal.fire({
              title: "Error!",
              text: "El motivo de anulación debe ser mayor a 15 caracteres.",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
              buttonsStyling: false
            });
          }
          else{
            this.annular(this.activeRow.id, this.activeRow.fecha, this.activeRow.nit, this.activeRow.invoiceAuthorization);
            swal.fire({
              title: "Éxito!",
              text: "Solicitud enviada.",
              icon: "success",
              customClass: {
                confirmButton: "btn btn-success",
              },
              buttonsStyling: false
            });
          }          
        }
      });
  }

  async annular(invoiceCode, invoiceDate, receiverTaxDocument, invoiceAuthorization) {
    this.isDisabled = true;

    if(this.reasonForCancellation == undefined || this.reasonForCancellation == '') {
      this.isDisabled = false;
      this._utilsService.showNotification(2, "Ingresar Motivo de Anulación");
      return;
    }
    else if(this.reasonForCancellation.length <= 15) {
      this.isDisabled = false;
      this._utilsService.showNotification(2, "El motivo de anulación debe ser mayor a 15 caracteres");
      return;
    }

    const json = {
      "invoice": {
        "invoiceCode": invoiceCode,
        "invoiceAuthorization": invoiceAuthorization,
        "invoiceDate": null,  //invoiceDate, //"2021-11-03T21:45:16.000-06:00",
        "invoiceComment": this.reasonForCancellation,
        "invoiceUser": this.company.companyPrefix,

      },
      "receiver": {
        "receiverTaxDocument": receiverTaxDocument
      },
      "transmitter": {
        "transmitterTaxDocument": this.company.companyTaxDocument,
        "transmitterUser": this.company.companyPrefix,
        "transmitterPrefix": this.company.companyPrefix, //estaba oculto
        "transmitterToken": this.company.companyToken, //estaba oculto
        "transmitterKey": this.company.companyKey
      },
      "provider": this.company.companyCertifier == 0 ? "infile" : "megaprint"
    };

    this.loading = true;
    // console.log(json);
    this._invoiceService.annular(json).then(
      async (response) => {
        console.log('response Digifact Cancel',response.records.infileServiceResponse);
        if (response.records.infileServiceResponse.status == true) {

          this.getAll();
          // Mostrar notificación
          this._utilsService.showNotification(1, response.records.infileServiceResponse.message);
        } else {
          // Mostrar notificación
          this._utilsService.showNotification(3, response.records.infileServiceResponse.message);
          this._utilsService.showNotification(3, response.records.infileServiceResponse.data.dnitResponseRaw);
          this.isDisabled = false;
        }
      },
      error => {
        // Mostrar notificacion
        this._utilsService.showNotification(2, error);
        console.log(error);
      }
    ).finally(() => {
      this.isDisabled = false;
      this.loading = false;
    });
  }

  async printLetter() {
    const pdfWindow = window.open("", 'Factura', '_blank');
    const css = `<style>   
        td { font-size: 12px; padding: 2px;}     
        .brDescr {border-right: 1px solid  #2CA8FF; border-top: 1px solid  #2CA8FF; border-bottom: 1px solid  #2CA8FF;}
        .brCompl {border-right: 1px solid  #2CA8FF; border-top: 1px solid  #2CA8FF;}
      </style>`;
    var html = `
    <head><title>Factura Clever "${this.company.companyName + ' - ' + this.fel.storeName}"</title></head>
    <body style="width: 21cm; height: 27cm; margin: auto; font-family: sans-serif, system-ui, monospace;"> 
      <div style="border: 2px solid #2CA8FF; border-radius: 10px; width: auto;">
        <table style="width: 100%;">
              <tr>
                  <td rowspan="5" style="width: 19%;">
                      <img style="width: 110px; margin:10px auto; display:block;" src="${this.companyLogoUrl}">
                  </td>
                  <th style="width: 62%; font-size: 19px; text-align: cent  er;">
                      ${this.fel.storeName}
                  </th>
                  <td style="width: 19%; font-size: 10px;">
                      Vendedor: ${this.activeRow.usuario}
                  </td>
              </tr>
              <tr>
                  <td style="text-align: center;">
                      ${this.company.companyName}
                  </td>
                  <td style="font-size: 10px;">Factura Electronica Fel</td>
              </tr>
              <tr>
                  <td style="text-align: center;">
                      NIT: ${this.company.companyTaxDocument}
                  </td>
                  <td>Serie: ${this.fel.invoiceSeries}</td>
              </tr>
              <tr>
                  <td style="text-align: center;">
                      Tel: ${this.fel.storePhone}<br>
                      ${this.fel.storeAddress}. ${this.fel.storeMunicipality}, ${this.fel.storeDepartment}
                  </td>
                  <td>No. DTE: ${this.fel.invoiceNumber}</td>
              </tr>
              <tr>
                  <th style="text-align: center;">FACTURA</th>
                  <td>Fecha: ${this.pipeFecha.transform(this.fel.invoiceDate, 'dd-MM-yyy')}</td>
              </tr>
        </table>
      </div>
      <br>
      <div style="border: 2px solid #2CA8FF; border-radius: 10px 10px 0px 0px; width: auto; min-height: 750px" >
        <table cellspacing="0" cellpadding="0" style="width: 100%;">
            <tr style="max-height: 15px;">
              <td colspan="4"> Nombre: ${this.felComplement.cliente}</td>
              <td colspan="3"> Nit: ${this.felComplement.nit}</td>
            </tr>
            <tr style="max-height: 15px;">
              <td colspan="7"> Dirección: ${this.felComplement.direccion}</td>
            </tr>
            <tr style="font-size: 11px; text-align: center;">
              <th class="brDescr">CANTIDAD</th>
              <th class="brDescr">TIPO</th>
              <th class="brDescr" style="width: 320px;">DESCRIPCIÓN</th>
              <th class="brDescr">PRECIO UNI.</th>
              <th class="brDescr">IMPUESTO</th>
              <th class="brDescr">DESCUENTO</th>
              <th class="brDescr" style="width: 120px;">TOTAL</th>
            </tr>`;

    for (const e of this.felDetail) {
      html += `<tr">
        <td style="text-align: center; "> ${e.cantidadCompra}</td>
        <td style="text-align: center;"> ${e.invoiceDetailType}</td>
        <td>${e.descripcionCompra}</td>
        <td style="text-align: right;"> ${e.precioUnitarioCompra}</td>
        <td style="text-align: right;"> ${e.invoiceDetailTax}</td>
        <td style="text-align: right;"> ${e.invoiceDetailDiscount}</td>
        <td style="text-align: right;"> ${e.totalCompra}</td>
        </tr>`
    };

    html += `          
        </table>
      </div>
      <div style="border: 2px solid #2CA8FF; border-radius: 0px 0px 10px 10px; width: auto;">
        <table cellspacing="0" style="width: 100%;">
              <tr>
                <td colspan="7" style="text-align: center; font-size: 10px;">Sujeto a pagos trimestrales ISR</td>
              </tr>
              <tr style="height: 30px;">
                <td class="brCompl" style="max-width: 22px; padding-left: 5px;">Total en Letras:</td>
                  <td class="brCompl" style="font-size: 10px max-width: 65px; text-align: left;">${this.pipeLetra.transform(this.fel.invoiceTotal)}</td>
                  <th style="font-size: 14px; max-width: 65px; text-align: right; border-top: 1px solid  #2CA8FF;">
                    TOTAL: Q ${this._pipeNumero.transform(this.fel.invoiceTotal, '1.2-2')}
                  </th>
              </tr>
          </table>
      </div> 
      <br>
      <table style="border: 2px solid #2CA8FF; border-radius: 10px; width: 100%;" padding: 10px;" >
          <tr><td>
            No. de Autorización: ${this.fel.invoiceAuthorization}<br>
            Fecha de Certificación: ${this.pipeFecha.transform(this.fel.invoiceDate, 'dd-MM-yyy')}
          </td></tr>
          <tr><td style="text-align: center">Certificador: ${this.felComplement.certificador}. Nit: ${this.felComplement.nitCertificador}</td></tr>
      </table>
    </body>`;

    await pdfWindow.document.write(css + html);
    setTimeout(() => { pdfWindow.window.open() }, 1100) //pdfWindow.window.print()
  }

  ///////////////////////DESCARGAR EXCEL///////////////////////
  async downloadToExcel() {
    const checkList = this.temp;
    const exportFile = new Array<any>();

    checkList.forEach(element => {
      let json = {};
      Object.keys(this.settings.columns).forEach((item, index, arr) => {
        if (this.settings.columns[item].type === "number") {
          json[this.settings.columns[item].title] = parseFloat(element[item]);
        } else {
          json[this.settings.columns[item].title] = element[item];
        }
      });
      exportFile.push(json);
    });
    const ws: xlsx.WorkSheet =
      xlsx.utils.json_to_sheet(exportFile);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Reporte');
    xlsx.writeFile(wb, 'reporte-anulacion.xlsx');
  }
}
